<template>
    <div class="mit-maps-page mit-page">
        <v-container fluid>
            <v-card class="mit-info-card">
              <v-card-title>New Person</v-card-title>
              <v-card-subtitle class="caption">Start adding a new person to CSAIL</v-card-subtitle>
              <v-divider></v-divider>

              <v-card-text>
                <!-- <v-btn>Back</v-btn> -->
                <MitActionsNewPersonWizard/>
              </v-card-text>
            </v-card>
      </v-container>
    </div>
</template>

<script>
  import MitActionsNewPersonWizard from '../../components/actions/MitActionsNewPersonWizard.vue';
  export default {
    name: 'MitActionNewPersonWizardPage',
    components: {
      MitActionsNewPersonWizard
    },
    data: function() {
      return {

      }
  },
    created(){

    },
    methods : {
    }
  }
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
